<template>
  <div class="m-activity-addAA">
    <el-form v-if="baseInfoEdit" ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="140px">
      <div class="base-box">
        <div class="title">基本设置</div>
        <el-form-item label="主办方" prop="mallIds">
          <el-select v-model="form.mallIds" placeholder="请选择主办方" :disabled="form.startSignUp" filterable>
            <el-option v-for="item in sponsorData" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入活动名称" :disabled="form.startSignUp" />
        </el-form-item>
        <el-form-item label="活动报名时间" prop="signUpDate">
          <el-date-picker
            v-model="form.signUpDate"
            type="datetimerange"
            range-separator=""
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="timestamp"
            format="yyyy/MM/dd HH:mm"
            :picker-options="pickerOptions"
            :disabled="form.startSignUp"
          >
          </el-date-picker>
          <span class="input-remark">*报名时间要早于活动时间</span>
        </el-form-item>
        <el-form-item label="活动时间" prop="activityDate">
          <el-date-picker
            v-model="form.activityDate"
            type="datetimerange"
            range-separator=""
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="timestamp"
            @change="activityDateChange"
            format="yyyy/MM/dd HH:mm"
            :picker-options="pickerOptions"
            :disabled="form.startSignUp"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="活动头图" prop="picture">
          <UploadImg name="picture" @getUploadFile="getUploadFile" :uploadUrl="form.picture" :width="400" desc="建议：上传690x290的jpg、png、jpeg图片" ></UploadImg>
        </el-form-item>
        <el-form-item label="活动标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入活动标题"/>
        </el-form-item>
        <el-form-item label="是否限制用户参加" prop="activityJoinLimit">
            <el-radio-group v-model="form.activityJoinLimit">
              <el-radio label="2">否</el-radio>
              <el-radio label="1">是</el-radio>
            </el-radio-group>
         </el-form-item>
         <el-form-item v-if="form.activityJoinLimit == 1" label-width="300px" label="指定限制会员标签" prop="memberLabel" :rules="[{ required: true, message: '标签不能为空'},]">
                  <el-select filterable v-model="form.memberLabel" multiple placeholder="请选择标签">
                    <el-option
                      v-for="(item, index) in labelOptions"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                      >
                    </el-option>
                  </el-select>
       </el-form-item>
        <el-form-item label="是否与其他活动同时报名" prop="togetherSignUp">
            <el-radio-group v-model="form.togetherSignUp">
              <el-radio label="2">否</el-radio>
              <el-radio label="1">是</el-radio>
            </el-radio-group>
            <span class="input-remark">*该条件限制单用户是否可参加多个活动</span>
         </el-form-item>
         <el-form-item label="过期自动退款" prop="refunddue">
        <el-radio-group v-model="form.refunddue">
          <el-radio :label="1">允许自动退款</el-radio>
          <el-radio :label="2">不允许自动退款</el-radio>
        </el-radio-group>
      </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入联系电话"/>
        </el-form-item>
        <el-form-item label="活动地址" prop="address">
          <el-input v-model="form.address" placeholder="请输入活动地址"/>
        </el-form-item>
        <el-form-item label="活动介绍" prop="description">
          <div style="border: 1px solid #ccc; margin-top: 10px;width: calc(100% - 40px);">
            <!-- 工具栏 -->
            <Toolbar
              style="border-bottom: 1px solid #ccc"
              :editor="editor"
              :defaultConfig="toolbarConfig"
            />
            <!-- 编辑器 -->
            <Editor
              style="height: 600px; overflow-y: hidden;"
              :defaultConfig="editorConfig"
              v-model="form.description"
              @onCreated="onCreated"
            />
          </div>
        </el-form-item>
      </div>
    </el-form>

    <div v-else class="base-info">
      <div class="base-info-baseSet">
        <div class="title">基本设置</div>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">主办方</el-col>
          <el-col :span="22" class="col-value">{{ form.mallName }}</el-col>
        </el-row>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">活动名称</el-col>
          <el-col :span="22" class="col-value">{{ form.name }}</el-col>
        </el-row>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">活动报名时间</el-col>
          <el-col :span="22" class="col-value">
            {{ form.signUpStartDate ? $moment(form.signUpStartDate).format('YYYY/MM/DD HH:mm:ss') : '' }}
            {{ form.signUpEndDate ? ' - ' + $moment(form.signUpEndDate).format('YYYY/MM/DD HH:mm:ss') : '' }}
          </el-col>
        </el-row>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">活动时间</el-col>
          <el-col :span="22" class="col-value">
            {{ form.startTime ? $moment(form.startTime).format('YYYY/MM/DD HH:mm:ss') : '' }}
            {{ form.endTime ? ' - ' + $moment(form.endTime).format('YYYY/MM/DD HH:mm:ss') : '' }}
          </el-col>
        </el-row>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">活动头图</el-col>
          <el-col :span="22" class="col-value">
            <div class="logo-box">
              <el-image v-if="form.picture" :src="form.picture" class="img" fit="contain" />
            </div>
          </el-col>
        </el-row>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">活动标题</el-col>
          <el-col :span="22" class="col-value">{{ form.title }}</el-col>
        </el-row>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">是否限制用户参加</el-col>
          <el-col :span="22" class="col-value">{{ form.activityJoinLimit == '1' ? '是':'否' }}</el-col>
        </el-row>
        <el-row class="row-info" v-if="form.activityJoinLimit == 1">
          <el-col :span="2" class="col-label">指定限制会员标签</el-col>
          <el-col :span="22" class="col-value">
             <span v-for="(item,index) in labelName" :key="index">{{ item.name }} </span>
          </el-col>
        </el-row>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">是否与其他活动同时报名</el-col>
          <el-col :span="22" class="col-value">{{ form.togetherSignUp == '1' ? '是':'否' }}</el-col>
        </el-row>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">过期自动退款</el-col>
          <el-col :span="22" class="col-value">{{ form.refunddue == '1' ? '允许自动退款':'不允许自动退款' }}</el-col>
        </el-row>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">联系电话</el-col>
          <el-col :span="22" class="col-value">{{ form.phone }}</el-col>
        </el-row>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">活动地址</el-col>
          <el-col :span="22" class="col-value">{{ form.address }}</el-col>
        </el-row>
        <el-row class="row-info">
          <el-col :span="2" class="col-label">活动介绍</el-col>
          <el-col :span="20" class="col-value">
            <div class="richtext-box" v-html="form.description"></div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div v-if="baseInfoEdit" class="button-box">
      <el-button @click="onCancel" class="mr20">取消</el-button>
      <el-button type="primary" @click="onNextStep" :loading="submitLoading">下一步</el-button>
    </div>
    <div v-else-if="isCanBaseInfoEdit" class="button-box">
      <auth-button auth="market:activity:update">
        <el-button type="primary" @click="onEdit" :loading="submitLoading" >编辑</el-button>
      </auth-button>
    </div>

    <el-divider />
    <!-- 奖品设置 -->
    <div class="ticket-set-box" v-if="!baseInfoEdit">
      <TicketSet :baseInfo="form" :isCanBaseInfoEdit="isCanBaseInfoEdit"></TicketSet>
    </div>

    <el-divider />
    <div class="buy-record-box" v-if="$route.query.page == 'detail'">
      <div class="title">购票记录</div>
      <BuyTicketRecord></BuyTicketRecord>
    </div>

  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import UploadImg from '@/components/UploadImg/index'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import editor from '@/mixins/editor'
import TicketSet from './components/ticketSet.vue'
import BuyTicketRecord from './components/buyTicketRecord.vue'
import { api_postApplyActivityAdd, api_postApplyActivityUpdate, api_getActivityBaseInfo } from '@/api/market'
import { api_getConfig, api_postFileUpload, api_getListLabel } from '@/api/common'

export default {
  name: "marketActivityAA",
  mixins: [ editor ],
  components: {
    AuthButton,
    UploadImg,
    Editor,
    Toolbar,
    TicketSet,
    BuyTicketRecord
  },
  data() {
    const checkFail = (rule, value, callback) => {
      if (!this.form.picture) {
        callback(new Error('请上传图片'))
      } else {
        callback()
      }
    }

    // 校验时间选择要大于当前时间
    const checkDate = (rule, value, callback) => {
      let startTime = this.$moment(value[0]).valueOf()
      let curTime = this.$moment(this.$moment().format('YYYY-MM-DD HH:mm')).valueOf()
      if (!this.form.startSignUp && (startTime < curTime)) {
        callback(new Error('开始时间需要在当前时间之后'))
      } else {
        callback()
      }
    }

    // 校验报名时间
    const checkApplyDate = (rule, value, callback) => {
      if (this.form.activityDate && (this.$moment(value[0]).valueOf() > this.$moment(this.form.activityDate[0]).valueOf())) {
        callback(new Error('报名开始时间要在活动开始时间之前'))
      } else if (this.form.activityDate && (this.$moment(value[1]).valueOf() > this.$moment(this.form.activityDate[1]).valueOf())) {
        callback(new Error('报名结束时间要在活动结束时间之前'))
      } else {
        callback()
      }
    }

    return {
      baseInfoEdit: true,
      submitLoading: false,
      isCanBaseInfoEdit: true,
      disabledFormItem: false,
      form: {
        type: 'SignUp', // 活动类型
      },
      rules: {
        mallIds: [{ required: true, message: '请选择主办方' }],
        name: [{ required: true, message: '请输入活动名称' }],
        activityDate: [
          { required: true, message: '请选择活动时间' },
          {validator: checkDate},
        ],
        signUpDate: [
          { required: true, message: '请选择活动报名时间' },
          {validator: checkDate},
          {validator: checkApplyDate},
        ],
        picture: [{ validator: checkFail }],
        title: [{ required: true, message: '请输入活动标题' }],
        phone: [{ required: true, message: '请输入联系电话' }],
        address: [{ required: true, message: '请输入活动地址' }],
        description: [{ required: true, message: '请输入活动介绍' }],
        activityJoinLimit: [{ required: true, message: '请选择是否限制用户参加' }],
        togetherSignUp: [{ required: true, message: '请选择是否可以与其他活动同时报名' }],
        refunddue: [{ required: true, message: '请选择活动到期是否自动退' }],
      },
      pickerOptions: {
        disabledDate: this.disabledDateFun,
      },
      sponsorData: [], // 主办方数据
      labelOptions: [],
      labelName:[],
    }
  },
  created() {
    this.getConfigData() // 获取config
    if (this.$route.query.id) {
      this.getBaseInfoData() // 获取活动基本信息数据
    }
    this.getListLabel()//获取会员标签
  },
  methods: {
    //获取会员标签
    async getListLabel() {
      this.labelOptions = await api_getListLabel()
    },
    // 获取活动基本信息数据
    async getBaseInfoData() {
      const { id, page } = this.$route.query
      const res = await api_getActivityBaseInfo({id: id})
      console.log('基本信息res: ', res);

      this.form = {
        ...res,
        mallIds: res.mallIds[0] || '',
        activityDate: [res.startTime, res.endTime],
        signUpDate: [res.signUpStartDate, res.signUpEndDate],
      }
      if ((res.status == 'Doing' || res.status == 'Ended')&&page == 'detail') {
        this.isCanBaseInfoEdit = false // 查看详情时，已结束、进行中状态不能编辑
      }

      this.form.togetherSignUp =  this.form.togetherSignUp == 1 ? '1':'2'
      this.form.activityJoinLimit =  this.form.activityJoinLimit == 1 ? '1':'2'
      // 处理指定会员标签
      this.labelName = []
      if (res.memberLabel) {
        this.form.memberLabel = this.form.memberLabel.split(',')
        let arry = this.form.memberLabel
        arry.forEach((item, index) => {
          this.form.memberLabel[index] = Number(item)
          this.labelOptions.forEach((items, indexs) => {
            if (items.id == item) {
              console.log(items.name)
              this.labelName.push({ name: items.name })
            }
          })
        })
      }
      console.log(this.labelName)
      this.baseInfoEdit = false
    },

    // 获取config
    async getConfigData() {
      const {mall} = await api_getConfig('mall')
      this.sponsorData = mall // 商场
    },

    // 活动时间改变
    activityDateChange() {
      this.$refs.form.validateField('signUpDate')
    },

    // 禁用日期
    disabledDateFun(date) {
      if (this.$moment(date).valueOf() < this.$moment().subtract(1, 'day').valueOf()) {
        return true
      }
    },

    // 点击下一步按钮 提交基本信息
    onNextStep() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          try {
            let { activityDate, signUpDate } = this.form
            let params = {
              ...this.form,
              mallIds: [this.form.mallIds],
              startTime: activityDate && activityDate[0] ? activityDate[0] : null,
              endTime: activityDate && activityDate[1] ? activityDate[1] : null,
              signUpStartDate: signUpDate && signUpDate[0] ? signUpDate[0] : null,
              signUpEndDate: signUpDate && signUpDate[1] ? signUpDate[1] : null,
            }

            // if(params.activityJoinLimit == 2){
            //   params.memberLabel = []
            // }
            delete params.activityDate
            delete params.signUpDate

            !params.id && (params.disable = false) // 创建活动时默认状态

            if (this.form.picture && this.form.picture.size) {
              const { key } = await api_postFileUpload(this.form.picture, 'Active')
              params.picture = key
            }

            console.log('params: ', params);
            // return

            let res = params.id ? await api_postApplyActivityUpdate(params) : await api_postApplyActivityAdd(params)
            console.log('res: ', res);
            this.$router.push({
              query: {
                ...this.$route.query,
                id: res.id
              }
            })
            this.getBaseInfoData()
            this.submitLoading = false
          } catch {
            this.submitLoading = false
          }
        }
      })
    },

    // 点击基本信息的编辑按钮
    onEdit() {
      this.baseInfoEdit = true
    },

    // 点击取消
    onCancel() {
      console.log(this.form.memberLabel)
      if (this.$route.query.id) {
        this.baseInfoEdit = false
      } else {
        this.$router.back(-1)
      }
    },

    getUploadFile (file, name) {
      this.form[name] = file
    },
  }
}
</script>

<style lang="scss" scoped>
.m-activity-addAA {
  width: 100%;
  padding: 35px 20px;
  padding-bottom: 100px;
  box-sizing: border-box;
  position: relative;

  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
    position: absolute;
    left: 410px;
    bottom: 0;
  }

  .el-input,
  .el-textarea,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 400px;
  }

  .button-box{
    text-align: right;
  }

  .logo-box {
    width: 400px;
    height: 150px;
    border: 1px solid #ccc;
    border-radius: 2px;

    .img {
      width: 100%;
      height: 100%;
    }
  }

  .row-info {
    min-height: 34px;
    line-height: 34px;
    margin-bottom: 20px;
    font-size: 14px;

    .col-label {
      text-align: right;
      padding-right: 20px;
      color: #666;
    }

    .col-value {
      color: #000;

      &.white-space {
        white-space: pre-wrap;
      }
    }
  }

  .richtext-box {
    width: 100%;
    height: 500px;
    overflow-y: auto;
    border: 1px solid #ccc;
  }

  .title {
    margin: 0;
    margin-bottom: 30px;
    padding-left: 15px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: relative;

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      width: 5px;
      height: 25px;
      border-radius: 2px;
      background: #05C8AF;
    }

    .title-remark {
      color: #666666;
      font-size: 14px;
    }
  }
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
